// Show the loaded preview immediately; request full detail only when zoom is used.
function magnify(image, zoomRatio, event) {
  const parent = image.parentElement;
  parent.querySelector('.image-magnify-full-size')?.remove();
  const overlay = document.createElement('div');
  overlay.className = 'image-magnify-full-size';
  overlay.setAttribute('aria-hidden', 'true');
  overlay.style.backgroundImage = `url("${image.currentSrc || image.src}")`;
  overlay.style.backgroundColor = 'var(--gradient-background)';
  const move = (pointer) => {
    const rect = image.getBoundingClientRect();
    overlay.style.backgroundPosition = `${((pointer.clientX - rect.left) / rect.width) * 100}% ${((pointer.clientY - rect.top) / rect.height) * 100}%`;
    overlay.style.backgroundSize = `${image.clientWidth * zoomRatio}px`;
  };
  overlay.onclick = () => overlay.remove();
  overlay.onmouseleave = () => overlay.remove();
  overlay.onmousemove = move;
  parent.insertBefore(overlay, image);
  move(event);
  if (image.currentSrc === image.src) return;
  const detail = new Image();
  detail.decoding = 'async';
  detail.fetchPriority = 'high';
  detail.onload = () => {
    if (overlay.isConnected) overlay.style.backgroundImage = `url("${detail.src}")`;
  };
  // A failure leaves the preview intact rather than stranding a spinner or dimming the image.
  detail.src = image.src;
}

function enableZoomOnHover(zoomRatio) {
  document.querySelectorAll('.image-magnify-hover').forEach((image) => {
    image.onclick = (event) => magnify(image, zoomRatio, event);
  });
}

enableZoomOnHover(2);
